module.exports = __webpack_public_path__ + "media/packs/images/flags/AF-caff4edc24575da6d88d813b54832c50.png";